export default {
  error_occurred: 'An error occurred. Please try again later.',
  oops: 'Oops!',
  okay: 'Okay',
  title_signout: 'Sign Out?',
  confirm_signout: 'You will be signed out of the following teams',
};
